
import * as PatternStore from '@/store/search/form/patterns';
import * as InterfaceStore from '@/store/search/form/interface';

import SelectPicker from '@/components/SelectPicker.vue';
import MultiValuePicker from '@/components/MultiValuePicker.vue';
import AlignBy from '@/pages/search/form/AlignBy.vue';
import CqlQueryBuilder from '@/components/cql/CqlQueryBuilder.vue';

import ParallelFields from '@/pages/search/form/parallel/ParallelFields';
import { CqlGenerator, CqlQueryBuilderData } from '@/components/cql/cql-types';

export default ParallelFields.extend({
	components: {
		SelectPicker,
		MultiValuePicker,
		AlignBy,
		CqlQueryBuilder
	},
	props: {
		errorNoParallelSourceVersion: { default: false, type: Boolean },
	},
	computed: {
		// The query (or source query, for parallel corpora)
		mainQuery: {
			get() { return PatternStore.getState().advanced.query; },
			set(v: any) { PatternStore.actions.advanced.query(v); }
		},

		// If this is a parallel corpus: the target queries
		targetQueries: {
			get() { return  PatternStore.getState().advanced.targetQueries; },
		},
	},
	methods: {
		copyAdvancedQuery() {
			const q = PatternStore.getState().advanced.query;
			PatternStore.actions.expert.query(q ? CqlGenerator.rootCql(q) : '');
			for (let i = 0; i < PatternStore.getState().advanced.targetQueries.length; i++) {
				PatternStore.actions.expert.changeTargetQuery({
					index: i,
					value: CqlGenerator.rootCql(PatternStore.getState().advanced.targetQueries[i]) || ''
				});
			}
			InterfaceStore.actions.patternMode('expert');
		},
		changeTargetQuery(index: number, value: CqlQueryBuilderData) {
			PatternStore.actions.advanced.changeTargetQuery({ index, value });
		}
	},
});
